import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import packageJson from '../../../../package.json';
const Footer = () => {
    const { t } = useTranslation();
    const version = packageJson.version;
    const environment = window._env_.REACT_APP_ENVIRONMENT;
    return (_jsx("div", Object.assign({ className: "main-footer-page" }, { children: _jsx("div", Object.assign({ className: "container-xl" }, { children: _jsxs("div", Object.assign({ className: "info-dev" }, { children: [_jsxs("span", { children: [t('common.version'), " ", version] }), environment !== 'Production' && _jsx("span", Object.assign({ className: 'ps-1' }, { children: environment }))] })) })) })));
};
export default Footer;
